import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Typography, Chip } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import moment from 'moment';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { createTheme, styled } from '@mui/material/styles';
const theme = createTheme();
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({

    paperContent: {
        boxShadow: 'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
    accordion: {
        backgroundColor: '#cccccc',

    },
    accordionHeader: {
        textTransform: 'uppercase',
        fontWeight: 600
    }
}));
const listStyle = {
    width: '100%',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
        width: '5px',
        height: '5px',
        backgroundColor: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#c1c1c1',
    }
}
const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(() => ({
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(180deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));
const AccordionDetails = styled(MuiAccordionDetails)(() => ({
    padding: '0 16px',
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));
const ActivityCheckList = (props) =>
{
    //const selected = useState([]);
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(true)
    const handleChange = (event, isExpanded) =>
    {
        setExpanded(isExpanded);

    };

    return (
        <Accordion expanded={expanded} onChange={handleChange}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${props.index + 1}bh-content`}
                id={`panel${props.index + 1}bh-header`}
                className={classes.accordion}
            >
                <Typography sx={{ width: '33%', flexShrink: 0 }} className={classes.accordionHeader}>
                    {props.date}
                </Typography>

            </AccordionSummary>
            <AccordionDetails>
                <List sx={listStyle} dense>
                    {props.data &&
                        props.data.map((item, index) =>
                        {
                            const labelId = `checkbox-list-label-${index}`;

                            return (
                                <ListItem key={`user_${index}`} disablePadding>
                                    <ListItemButton
                                        role={undefined}
                                        onClick={() => props.checkUsers(item.actualData.activityID)}
                                        dense>
                                        <ListItemIcon sx={{ flex: '0.05' }}>
                                            <Checkbox
                                                edge="start"
                                                checked={
                                                    props.selected.indexOf(item.actualData.activityID) !== -1
                                                }
                                                tabIndex={-1}
                                                disableRipple
                                                inputProps={{
                                                    'aria-labelledby': labelId,
                                                }}
                                            />
                                        </ListItemIcon>
                                        <ListItemText sx={{ textAlign: 'left', flex: '0.2' }}
                                            id={labelId}
                                            primary={(item.actualData.startDateTime !== null && item.actualData.endDateTime !== null) ?
                                                `${moment(item.actualData.startDateTime).format('hh:mm A')} to ${moment(item.actualData.endDateTime).format('hh:mm A')}` :
                                                (item.actualData.startDateTime !== null && item.actualData.endDateTime == null) ?
                                                    `${moment(item.actualData.startDateTime).format('hh:mm A')} to ` :
                                                    (item.actualData.startDateTime === null && item.actualData.endDateTime !== null) ?
                                                        ` to ${moment(item.actualData.startDateTime).format('hh:mm A')}` : ''}
                                        />
                                        <ListItemText sx={{ textAlign: 'left', flex: '0.2', wordBreak: 'break-word' }}

                                            primary={item.actualData.activityName}
                                        />
                                        <ListItemText sx={{ textAlign: 'left', flex: '0.2', wordBreak: 'break-word' }}

                                            primary={item.actualData.location}
                                        />
                                        <ListItemText sx={{ textAlign: 'left', flex: '0.3' }}
                                        >
                                            {item.actualData.activityTags !== null && item.actualData.activityTags.map((tag, i) =>
                                            {
                                                return <Chip key={i} sx={{ mr: '4px', mb: '2px' }} label={tag.tagName} />
                                            })}
                                        </ListItemText>
                                    </ListItemButton>
                                </ListItem>
                            );
                        })}
                </List>
            </AccordionDetails>
        </Accordion>
    );
};

export default ActivityCheckList;
